<div class="modal right" id="newEarning" tabindex="-1" role="dialog" aria-labelledby="newEarningLabel">
	<div class="modal-dialog" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header hide-print">
				<div class="modal-title">
					<h4 id="newEarningLabel" ng-if="!earning.id">New Earning</h4>
					<h4 id="newEarningLabel" ng-if="earning.id">Edit Earning</h4>
				</div>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<i class="icon-close-circle"></i>
				</button>
			</div>
			<div class="modal-body order-detail-page">
				<div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="save()" class="form-horizontal allcp-form">
										<div class="form-group floating">
											<input id="date" type="text" autocomplete="off"
												class="form-control input-md" placeholder="Date" required
												ng-model="earning.date">
											<label>Date</label>
										</div>
										
										<div class="form-group floating">
											<select id="type" autocomplete="off" class="form-control input-md"
												name="type" ng-model="earning.worker_id" required
												ng-options="o.id as o.full_name for o in data.workers">
												<option value="">Select Driver</option>
											</select>
											<label>Driver</label>
										</div>

										<div class="form-group floating">
											<input type="text" ng-model="earning.price" class="form-control input-md"
												placeholder="Price" required>
											<label>Price</label>
										</div>

										<!-- <div class="form-group floating">
											<input type="text" ng-model="earning.qty" class="form-control input-md"
												placeholder="Qty" required>
											<label>Qty</label>
										</div> -->

										<!-- <div class="form-group floating">
											<input type="text" ng-model="earning.total" ng-value="getEarningPrice(earning)" ng-disabled="true" class="form-control input-md"
												placeholder="Total" required>
											<label>Total </label>
										</div> -->

										<div class="form-group floating">
											<select id="type" name="type" ng-model="earning.status"
												class="form-control input-md" required
												ng-options="o.id as o.name for o in statuses">
												<option value="">Select Status</option>
											</select>
											<label>
												Status
											</label>
										</div>

										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue">
													<span ng-if="!earning.id">CREATE</span>
													<span ng-if="earning.id">UPDATE</span>
													</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>